/**
 * ComeFunzionaPage — pagina dedicata `/come-funziona`.
 *
 * iter v31 r53 — User: «il come funziona e filosofia forse lo togliamo
 * dalla landing e lo fai in una pagina nuova che se uno clicca come
 * funziona lo porta lì, così la landing rimane più pulita».
 *
 * Wrapping della sezione ComeFunziona riusabile, con header navigation
 * e footer della landing, più un CTA finale.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderV2 from "@/pages/landing/v2/HeaderV2";
import ComeFunziona from "@/pages/landing/v2/ComeFunziona";
import { ArrowRight } from "@phosphor-icons/react";

export default function ComeFunzionaPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#1C1C1A]">
      <HeaderV2 />
      <ComeFunziona />

      {/* CTA in fondo per portare l'utente alla registrazione */}
      <section className="py-14 sm:py-20 bg-[#1C1C1A] text-white" data-testid="cf-page-final-cta">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <h2 className="font-editorial text-[28px] sm:text-[40px] leading-[1.05] tracking-tight">
            Pronto sembra fatto per te?
            <br />
            <span className="italic text-white/70">Prova gratis.</span>
          </h2>
          <p className="mt-4 text-[14px] sm:text-[15px] text-white/75 leading-relaxed max-w-xl mx-auto">
            Senza carta. Senza vincoli. Disdici dal pannello in un click.
            Gratis per i primi che entrano.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/register")}
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-[#FAFAF7] text-[#1C1C1A] px-6 py-3.5 rounded-xl font-semibold text-[14.5px] transition-colors active:scale-[0.98]"
              data-testid="cf-page-register-btn"
            >
              Apri il mio account
              <ArrowRight size={15} weight="bold" />
            </button>
            <button
              onClick={() => navigate("/")}
              className="inline-flex items-center justify-center text-white/80 hover:text-white px-6 py-3.5 rounded-xl text-[14px] font-medium border border-white/15 hover:border-white/30 transition-colors"
              data-testid="cf-page-back-landing-btn"
            >
              Torna alla home
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
